import websiteConfigurationService from "../../../services/websiteConfiguration.service";
import { websiteConfigurationActionTypes } from "../../actionTypes/websiteConfiguration/websiteConfiguration.actionTypes";

// Add or Update Configuration
export const addOrUpdateConfiguration = (configurationData) => async (dispatch) => {
  try {
    dispatch({ type: websiteConfigurationActionTypes.START_ADD_OR_UPDATE_CONFIGURATION });
    const response = await websiteConfigurationService.addOrUpdateConfiguration(configurationData);
    dispatch({
      type: websiteConfigurationActionTypes.ADD_OR_UPDATE_CONFIGURATION_SUCCESS,
      data: response.data.payload,
    });
    return response.data;
  } catch (ex) {
    console.error("Add or Update Configuration Error:", ex.message);
    dispatch({ type: websiteConfigurationActionTypes.ADD_OR_UPDATE_CONFIGURATION_FAILURE, error: ex.response?.data });
    throw ex.response?.data;
  }
};

// Delete Configuration
export const deleteConfiguration = (key) => async (dispatch) => {
  try {
    dispatch({ type: websiteConfigurationActionTypes.START_DELETE_CONFIGURATION });
    const response = await websiteConfigurationService.deleteConfiguration(key);
    dispatch({ type: websiteConfigurationActionTypes.DELETE_CONFIGURATION_SUCCESS });
    return response.data;
  } catch (ex) {
    console.error("Delete Configuration Error:", ex.message);
    dispatch({ type: websiteConfigurationActionTypes.DELETE_CONFIGURATION_FAILURE, error: ex.response?.data });
    throw ex.response?.data;
  }
};

// Get Configuration by Key
export const getConfigurationByKey = (key) => async (dispatch) => {
  try {
    dispatch({ type: websiteConfigurationActionTypes.START_GET_CONFIGURATION_BY_KEY });
    const response = await websiteConfigurationService.getConfigurationByKey(key);
    dispatch({
      type: websiteConfigurationActionTypes.GET_CONFIGURATION_BY_KEY_SUCCESS,
      data: response.data.payload,
    });
    return response.data;
  } catch (ex) {
    console.error("Get Configuration by Key Error:", ex.message);
    dispatch({ type: websiteConfigurationActionTypes.GET_CONFIGURATION_BY_KEY_FAILURE, error: ex.response?.data });
    throw ex.response?.data;
  }
};

// Get All Configurations
export const getAllConfigurations = () => async (dispatch) => {
  try {
    dispatch({ type: websiteConfigurationActionTypes.START_GET_ALL_CONFIGURATIONS });
    const response = await websiteConfigurationService.getAllConfigurations();
    dispatch({
      type: websiteConfigurationActionTypes.GET_ALL_CONFIGURATIONS_SUCCESS,
      data: response.data.payload,
    });
    return response.data;
  } catch (ex) {
    console.error("Get All Configurations Error:", ex.message);
    dispatch({ type: websiteConfigurationActionTypes.GET_ALL_CONFIGURATIONS_FAILURE, error: ex.response?.data });
    throw ex.response?.data;
  }
};

// Upload Logo Image
export const uploadImage = (type, formData) => async (dispatch) => {
  try {
    dispatch({ type: websiteConfigurationActionTypes.START_UPLOAD_IMAGE });
    const response = await websiteConfigurationService.uploadImage(type, formData);
    dispatch({
      type: websiteConfigurationActionTypes.UPLOAD_IMAGE_SUCCESS,
      data: response.data.payload,
    });
    return response.data;
  } catch (ex) {
    console.error("Upload configuration Image Error:", ex.message);
    dispatch({ type: websiteConfigurationActionTypes.UPLOAD_IMAGE_FAILURE, error: ex.response?.data });
    throw ex.response?.data;
  }
};

// Delete Home Banner
export const deleteHomeBanner = (bannerId) => async (dispatch) => {
  try {
    dispatch({ type: websiteConfigurationActionTypes.START_DELETE_HOME_BANNER });
    const response = await websiteConfigurationService.deleteHomeBanner(bannerId);
    dispatch({ type: websiteConfigurationActionTypes.DELETE_HOME_BANNER_SUCCESS });
    return response.data;
  } catch (ex) {
    console.error("Delete Home Banner Error:", ex.message);
    dispatch({ type: websiteConfigurationActionTypes.DELETE_HOME_BANNER_FAILURE, error: ex.response?.data });
    throw ex.response?.data;
  }
};

const websiteConfigurationActions = {
  addOrUpdateConfiguration,
  deleteConfiguration,
  getConfigurationByKey,
  getAllConfigurations,
  uploadImage,
  deleteHomeBanner
};

export default websiteConfigurationActions;
